import { RESET_APP_STATE } from '../actionTypes/pageGlobal'

/**
 * Global reset action to clear accumulated data and prevent memory leaks
 * This action should be dispatched when navigating between major sections
 * (Dashboard <-> Campaigns) to clear bulk data that may cause browser hanging
 */
export const resetAppState = () => ({
  type: RESET_APP_STATE
})